export interface PublicRegistry {
  title: string;
  value: string;
}

export const PUBLIC_REGISTRY_OPTIONS: PublicRegistry[] = [
  {
    value: "xgs",
    title: "Xia-Gibbs Syndrome Registry",
  },
  {
    value: "bsyn",
    title: "Bloom",
  },
  {
    value: "ws",
    title: "Werner",
  },
  {
    value: "rts",
    title: "Rothmund-Thomson Syndrome",
  },
  {
    value: "xgs_old",
    title: "Xia-Gibbs Syndrome Registry",
  }
];

export const DEFAULT_PUBLIC_REGISTRY = PUBLIC_REGISTRY_OPTIONS[0];
